import getFetchOptions from 'utils/getFetchOptions';

import { PaginatedResponse, handlePaginatedResponse, toQueryString } from '../utils';
import { DisputesQueryParams, DisputesResponse } from './disputes.types';

export const getDisputes = async (
  apiAprilBaseUri: string,
  queryParams: DisputesQueryParams,
): Promise<PaginatedResponse<DisputesResponse>> => {
  let qParams = toQueryString(queryParams);
  const options = await getFetchOptions('GET');
  return await fetch(`${apiAprilBaseUri}/transactions/disputes${qParams}`, options).then(handlePaginatedResponse);
};
